import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';
import { surfaceFromHost, destinoExpulsion } from '../surface';

const AuthContext = createContext(null);

// Roles dedicados (sac, contratos) no usan el panel: se los expulsa a su dominio, pero
// SOLO cuando están en la superficie 'panel'. En su propia superficie son bienvenidos
// (si no, entrarían a su dominio y se auto-redirigirían en loop).
// Se aplica en CUALQUIER resolución de sesión (login por formulario Y token preexistente
// al navegar directo), no solo en el login — así un token de estos roles tampoco abre el
// panel: se limpia y se manda a su dominio.
function _redirigirFueraDelPanel(userData) {
  const surface = surfaceFromHost(typeof window !== 'undefined' ? window.location.hostname : '');
  const destino = userData && destinoExpulsion(surface, userData.role);
  if (destino) {
    localStorage.removeItem('token');
    window.location.href = destino;
    return true;
  }
  return false;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }
    api.get('/auth/me')
      .then((res) => {
        if (_redirigirFueraDelPanel(res.data)) return;
        setUser(res.data);
      })
      .catch(() => localStorage.removeItem('token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const params = new URLSearchParams({ username, password });
    const res = await api.post('/auth/login', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
    localStorage.setItem('token', res.data.access_token);
    const me = await api.get('/auth/me');
    if (_redirigirFueraDelPanel(me.data)) return;
    setUser(me.data);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
